import { FAQ_CATEGORIES } from "./faqCategories.constants";
import { action } from "src/utils/requestActions";

export function requestFaqCategories() {
  return action(FAQ_CATEGORIES.REQUEST);
}
